var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.6364H12.6364V16V16.6364H11.3636V16V15.6364H11H9.36364V14.3636H13H13.3636V14V13V12.6364H13H10C9.65083 12.6364 9.36364 12.3492 9.36364 12V9C9.36364 8.65083 9.65083 8.36364 10 8.36364H11H11.3636V8V7.36364H12.6364V8V8.36364H13H14.6364V9.63636H11H10.6364V10V11V11.3636H11H14C14.3492 11.3636 14.6364 11.6508 14.6364 12V15C14.6364 15.3492 14.3492 15.6364 14 15.6364H13ZM2.37364 6.0003V6C2.37364 5.08845 3.09321 4.36364 4 4.36364H20C20.9092 4.36364 21.6364 5.09083 21.6364 6V18C21.6364 18.9092 20.9092 19.6364 20 19.6364H4C3.09088 19.6364 2.36372 18.9092 2.36364 18.0002C2.36364 18.0001 2.36364 18 2.36364 18L2.37364 6.0003ZM20 18.3636H20.3636V18V6V5.63636H20H4H3.63636V6V18V18.3636H4H20Z",
    fill: "#006F9B",
    stroke: "#006F9B",
    strokeWidth: 0.727273
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarOutline);
export default __webpack_public_path__ + "static/media/dollar_outline.f164a4dacd8e0af60ee097ca2d5a5c95.svg";
export { ForwardRef as ReactComponent };